// BASE FORM FIELDS
import string from './string';
import numeric from './numeric';
import autocomplete from './autocomplete';
import select from './select';
import date from './date';
import switchField from './switch';
import checkbox from './checkbox';
import radio from './radio';
import address from './address';
import value from './value';
import slider from './slide';
import submit from './submit';
import array from './array';
import remove from './remove';
import removeEdit from './remove-edit';
import state from './state';
import file from './file';
import textarea from './text-area';
import csvFile from './csv-file-upload';
import chipArray from './chip-array';

// BUSINESS SPECIFIC LOGIC FORM FIELDS
import affinity from './affinity';
import mortgageLenderName from './mortgage-lender-name';

export const fieldTypes = {
  string,
  numeric,
  autocomplete,
  select,
  date,
  switch: switchField,
  checkbox,
  radio,
  address,
  value,
  slider,
  submit,
  array,
  remove,
  removeEdit,
  state,
  affinity,
  mortgageLenderName,
  file,
  textarea,
  csvFile,
  chipArray
};
